module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvaW1nL3Fjb2RlLjJkZTUyNGRmLnN2ZyI7"